import { render, staticRenderFns } from "./contact_nav.vue?vue&type=template&id=90990f6c&scoped=true&"
import script from "./contact_nav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./contact_nav.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./contact_nav.vue?vue&type=style&index=0&id=90990f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90990f6c",
  null
  
)

export default component.exports